import { Liability } from '../../liabilities/models/liability.model';
import { Observable } from 'rxjs';
import { LiabilityDelegationData } from '../models/liability-delegation-data.model';
import { ApiService } from '../../core/services/api.service';
import { Injectable } from '@angular/core';
import { SubAccountDelegationData } from '../models/sub-account-delegation-data.model';
import { CustomerBillerDelegationData } from '../models/customer-biller-delegation-data.model';
@Injectable({
  providedIn: 'root',
})
export class LiabilitiesDelegateApiService {
  constructor(private apiService: ApiService) {}

  public delegateSingleLiability(data: LiabilityDelegationData): Observable<void> {
    return this.apiService.post(
      `/liability-delegation/${data.customerBillerId}/liabilities/${data.liabilityId}`,
      data.delegatedEmail,
    );
  }

  public delegateForCustomerBiller(data: CustomerBillerDelegationData): Observable<void> {
    return this.apiService.post(`/liability-delegation/${data.customerBillerId}`, data.delegatedEmail);
  }

  public delegateForSubAccount(data: SubAccountDelegationData): Observable<void> {
    return this.apiService.post(
      `/liability-delegation/${data.customerBillerId}/subaccounts`,
      data.subAccountDelegation,
    );
  }

  public deleteSingleLiabilityDelagation(liabilityId: string): Observable<Liability> {
    return this.apiService.delete(`/liability-delegation/liabilities/${liabilityId}`);
  }

  public deleteSubAccountDelagation(customerBillerId: string, accountSubaccountId: string): Observable<void> {
    return this.apiService.delete(`/liability-delegation/${customerBillerId}/subaccounts/${accountSubaccountId}`);
  }

  public deleteCustomerBillerDelagation(customerBillerId: string): Observable<void> {
    return this.apiService.delete(`/liability-delegation/${customerBillerId}`);
  }
}
